import React from 'react'

const AcademyCourseCard = ({ title, time, text }) => {
    return (
        <div className="courseCardCont">
            <div className="flexAcaCard">
                <div className="leftCardTitle">
                    <h1 className="courseTit">{title}</h1>
                    <p className="estiTime">ESTIMATED TIME: {time}HRS</p>
                </div>
                <div className="rightComp">
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.0054 3.64844H4.00537C2.9008 3.64844 2.00537 4.54387 2.00537 5.64844V15.6484C2.00537 16.753 2.9008 17.6484 4.00537 17.6484H20.0054C21.1099 17.6484 22.0054 16.753 22.0054 15.6484V5.64844C22.0054 4.54387 21.1099 3.64844 20.0054 3.64844Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M8.00537 21.6484H16.0054" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12.0054 17.6484V21.6484" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>
            <p className="courseText">{text}</p>
            <p className="priceTag">FREE</p>
        </div>
    )
}

export default AcademyCourseCard
